const FacultyMedicineSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 35 35" fill="none">
      <path
        d="M24.7913 7.29169V10.2084C25.9517 10.2084 27.0645 10.6693 27.8849 11.4898C28.7054 12.3102 29.1663 13.423 29.1663 14.5834V30.625C29.1663 31.0118 29.0127 31.3827 28.7392 31.6562C28.4657 31.9297 28.0948 32.0834 27.708 32.0834H7.29134C6.90457 32.0834 6.53363 31.9297 6.26014 31.6562C5.98665 31.3827 5.83301 31.0118 5.83301 30.625V14.5834C5.83301 13.423 6.29394 12.3102 7.11442 11.4898C7.93489 10.6693 9.04769 10.2084 10.208 10.2084V7.29169H24.7913ZM18.958 16.0417H16.0413V18.9584H13.1247V21.875H16.0399L16.0413 24.7917H18.958L18.9565 21.875H21.8747V18.9584H18.958V16.0417ZM27.708 2.91669V5.83335H7.29134V2.91669H27.708Z"
        fill="#5D6977"
      />
    </svg>
  );
};

export default FacultyMedicineSvg;
